import React from "react"
import { Link } from "gatsby"

import logotype from "../images/logotype.svg"
import Menu from "./menu"

const Header = () => (
  <header className="header menu-position-adjuster">
    {/* Wrapper prevents link element to fill the whole column width */}
    <div>
      <Link to="/" className="logotype-wrapper">
        <img
          className="logotype"
          src={logotype}
          height="60px"
          width="349px"
          alt="logotype"
        />
      </Link>
    </div>
    <Menu />
  </header>
)

export default Header
